import AppStoreAppleImage from '../../assets/app-store-apple.png';
import AppStoreGoogleImage from '../../assets/app-store-google.png';
import Grid from '@mui/joy/Grid';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import { useState } from 'react';
import { createTracker } from '../../utils/log';
import { useAppContext } from '../../context/AppContext';

const AppButtons = ({ width = 158 }) => {
    const [showAndroidModal, setShowAndroidModal] = useState(false);
    const { andee, sessionInfo } = useAppContext();
    const trackEvent = createTracker(andee, sessionInfo);

    function handleIOSDownloadClick() {
        trackEvent('button_clicked', { button_name: 'ios_download' });
    }

    function handleAndroidDownloadClick(e) {
        e.preventDefault();
        trackEvent('button_clicked', { button_name: 'android_download' });
        setShowAndroidModal(true);
    }

    return (
        <Grid sx={{ flexGrow: 1 }} container spacing={2}>
            <Grid xs={12}>
                <Grid container justifyContent="center" spacing={1}>
                    <Grid key="apple">
                        <a onClick={handleIOSDownloadClick} href="https://apps.apple.com/us/app/and/id1556305221" target="_blank" rel="noreferrer">
                            <img src={AppStoreAppleImage} width={width} alt="Download iOS app" />
                        </a>
                    </Grid>
                    <Grid key="google">
                        <a href="#" onClick={handleAndroidDownloadClick} target="_blank" rel="noreferrer" >
                            <img src={AppStoreGoogleImage} width={width} alt="Download Android app" />
                        </a>
                    </Grid>
                </Grid>
            </Grid>
            <Modal
                open={showAndroidModal}
                onClose={() => {
                    setShowAndroidModal(false);
                }}
            >
                <ModalDialog aria-labelledby="dialog-vertical-scroll-title" >
                    & for Android will be re-released with all new features in Fall 2023
                </ModalDialog>
            </Modal>
        </Grid>
    );
};

export default AppButtons;
